export default __webpack_public_path__ + "static/media/SWT0090.34I-21359_-14899_0.d6e73d84.jpg";